import CodeBlockToolbarView from "./CodeBlockToolbarView.vue";
import {CodeBlock as CodeBlockExtension} from "@tiptap/extension-code-block";

export default class CodeBlock {

    constructor() {
        this.toolbarView = CodeBlockToolbarView;
    }

    static create() {
        return new CodeBlock();
    }

    getExtensions() {
        return [CodeBlockExtension];
    }
}